var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.searchData && _vm.searchData.type === "star_summary"
      ? _c(
          "div",
          [
            _c("div", { staticClass: "star-home-top" }, [_c("StarHead")], 1),
            _vm._v(" "),
            _vm._l(_vm.starEntity.entity || [], function (item, index) {
              return _c("div", { key: index }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.starTab === item.doctype,
                        expression: "starTab === item.doctype",
                      },
                    ],
                  },
                  [
                    ["film", "teleplay", "tvshow"].indexOf(item.doctype) > -1
                      ? _c("ClassList", {
                          attrs: {
                            "data-list": item.results,
                            type: item.doctype,
                            "get-uigs": _vm.getUigs,
                            "show-loading": !_vm.loadingFinished,
                          },
                        })
                      : _c("ShortVideo", {
                          attrs: {
                            "short-video": item.results,
                            "get-uigs": _vm.getUigs,
                            "get-uigs-play-info": _vm.getShortVideoPlayInfo,
                            "show-loading": !_vm.loadingFinished,
                            "search-data": _vm.searchData,
                            "star-tab": _vm.starTab,
                          },
                        }),
                  ],
                  1
                ),
              ])
            }),
            _vm._v(" "),
            _c("Gotop"),
          ],
          2
        )
      : _c("div", [_c("NoResult"), _vm._v(" "), _c("Gotop")], 1),
    _vm._v(" "),
    _c("div", {
      staticStyle: { display: "none" },
      domProps: { innerHTML: _vm._s("<!--star-->") },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }